import React from 'react'
import cx from 'classnames'

import styles from './Card.module.css'
import CardSelectedIcon from 'Images/onboarding_tick_black_bg.svg'

const CardContentContainer = ({ dataSource, children, className }) => {
  return (
    <div
      className={cx(styles.CardContentContainer, className, {
        [styles.EmptyContainer]: !dataSource || dataSource.length === 0
      })}
    >
      {children}
    </div>
  )
}

const Card = (props) => {
  const { data, onSelectCard, stepId } = props

  const handleSelectCard = () => {
    onSelectCard(data)
  }

  return (
    <div className={cx(styles.CardContainer, { [styles.Selected]: data.selected })}>
      <button className={styles.CardButtonBase} tabIndex='0' type='button' onClick={handleSelectCard}>
        <div className={`${styles.CardContent}`}>
          <div className={styles.CardTitle}> {data.title} </div>
          <p className={styles.CardSubtitle}>{data.subtitle}</p>
          {data.selected ? (
            <CardSelectedIcon className={styles.CardCheckedIcon} />
          ) : (
            stepId === 2 && <div className={styles.CardNotChecked} />
          )}
        </div>
        <img className={styles.CardMediaImage} src={data.imageURL} alt={data.imageName} />
      </button>
    </div>
  )
}

export { Card, CardContentContainer }
